<script>
import { useAlert } from 'dashboard/composables';
export default{
    name: "DeleteConfirmationModal",
    props: {
        deleteName: {
            type: String,
            required: true
        },
        isDeleting: {
            type: Boolean,
            default: false
        }
    },
    emits: ['confirm-delete', 'close']
}
</script>

<template>
    <div class="fixed inset-0 flex items-center justify-center bg-slate-800/50 px-4">
        <div class="p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-xl max-w-sm w-full">            
            <h1 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3">
                {{ $t('BRANCHES.DELETE_CONFIRMATION_MODAL.TITLE') }}
            </h1>
            <p class="text-sm text-gray-700 dark:text-gray-300 mb-6" v-html="$t('BRANCHES.DELETE_CONFIRMATION_MODAL.MESSAGE', { name: deleteName })">
            </p>
            <div class="flex justify-end space-x-2">
                <woot-button
                    variant="smooth"
                    color-scheme="secondary"
                    icon="cancel"
                    :disabled="isDeleting"
                    @click="$emit('close')"
                >
                    {{ $t('BRANCHES.DELETE_CONFIRMATION_MODAL.CANCEL_BUTTON') }}
                </woot-button>
                <woot-button
                    variant="smooth"
                    color-scheme="alert"
                    icon="delete"
                    :disabled="isDeleting"
                    @click="$emit('confirm-delete')"
                >
                    {{ isDeleting ? $t('BRANCHES.DELETE_CONFIRMATION_MODAL.DELETING') : $t('BRANCHES.DELETE_CONFIRMATION_MODAL.DELETE_BUTTON') }}
                </woot-button>
            </div>
        </div>
    </div>
</template>
